export default __webpack_public_path__ + "static/media/Shadowed Valleys-18.f00bff89.jpg";